import { configs } from '$configs';
import { SORT, COLORS } from '$gbusiness/enums';
import CellModel from '$gbusiness/models/cell';
import { defaultDataSource, defaultStyles, TableModel } from '$gbusiness/models/table';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Button } from '@mui/material';
import { deriveRawToInvoiceType } from '$fbusiness/models/invoiceType';

export const INVOICE_TYPE_TABLE_CONFIG: TableModel = {
  dataSource: {
    ...defaultDataSource,
    endpoint: configs.api.invoiceType,
    method: 'GET',
    deriveToModel: deriveRawToInvoiceType,
    defaultSortKey: 'createdAt',
    defaultSortOrder: SORT.DSC,
    shouldVirtualize: false,
    pageSize: 20,
  },
  styles: {
    ...defaultStyles,
    color: COLORS.LIGHT,
    fontSize: '1em',
    minWidth: 300,
    maxWidth: 800,
    cellPadding: ` 8px 4px`,
    isStripped: true,
    responsive: true,
  },
  filter: {
    color: COLORS.PRIMARY,
  },
};

export const INVOICE_TYPE_TABLE = (): Array<CellModel> => [
  {
    label: 'SCREEN.INVOICE_TYPES.COLS.NAME',
    value: 'name',
    alwaysShow: true,
    sortable: SORT.ASC,
    width: 250,
  },
  {
    label: 'SCREEN.INVOICE_TYPES.COLS.LEVEL',
    value: 'userLevel.label',
    alwaysShow: true,
    sortable: SORT.ASC,
    width: 250,
  },
  {
    label: '',
    value: '',
    className: 'action',
    align: 'center',
    component: (row, actions) => {
      return (
        <Button
          className="left"
          color="secondary"
          fullWidth
          onClick={(e) => actions.handlePopoverOpen(e, row)}>
          <MoreHorizIcon />
        </Button>
      );
    },
    width: 100,
  },
];
